import Skeleton from 'react-loading-skeleton';
import { BasePage } from './BasePage';

export function LoadingPage(): JSX.Element {
    return (
        <BasePage title={gettext('LOADING')} titleNode={<Skeleton />}>
            <Skeleton count={10} />
        </BasePage>
    );
}
